import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    title: "Manicures & Pedicures",
    description: "Classic care for hands and feet — shaping, cuticle work and a flawless polish finish.",
    image: "/gallery/work-4.webp",
    alt: "Soft pink classic manicure by Teo's Nails",
    span: "md:col-span-5",
    testid: "service-card-manicure-pedicure",
  },
  {
    title: "Gel & Acrylic Nails",
    description: "Long-lasting gel and acrylic sets, built to stay perfect for weeks.",
    image: "/gallery/work-2.webp",
    alt: "Pink French gel set with glitter accent by Teo's Nails",
    span: "md:col-span-7",
    testid: "service-card-gel-acrylic",
  },
  {
    title: "Full Nail Art & Custom Designs",
    description: "From subtle accents to full custom sets — designed around your style.",
    image: "/gallery/work-5.webp",
    alt: "White French nails with crystal details by Teo's Nails",
    span: "md:col-span-7",
    testid: "service-card-nail-art",
  },
];

export const Services = () => (
  <section id="services" data-testid="services-section" className="py-24 md:py-32">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="mb-16 max-w-2xl">
        <p className="mb-4 text-xs font-semibold uppercase tracking-[0.2em] text-brand-accent">Services</p>
        <h2 className="font-display text-4xl font-medium tracking-tight text-brand-ink md:text-5xl">
          Treatments made to be admired
        </h2>
      </div>
      <div className="grid grid-cols-1 gap-8 md:grid-cols-12">
        {SERVICES.map((service, i) => (
          <motion.article
            key={service.title}
            initial={{ opacity: 0, y: 32 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.7, delay: 0.1 * i, ease: [0.22, 1, 0.36, 1] }}
            data-testid={service.testid}
            className={`group overflow-hidden rounded-2xl border border-brand-muted bg-white shadow-[0_8px_32px_rgba(45,27,34,0.04)] transition-transform duration-300 hover:-translate-y-1 hover:shadow-lg ${service.span}`}
          >
            <div className="overflow-hidden">
              <img
                src={service.image}
                alt={service.alt}
                loading="lazy"
                className="aspect-[3/4] w-full object-cover transition-transform duration-500 group-hover:scale-105"
              />
            </div>
            <div className="p-8">
              <h3 className="font-display text-2xl font-semibold tracking-tight text-brand-ink md:text-3xl">
                {service.title}
              </h3>
              <p className="mt-3 text-base leading-relaxed text-brand-ink/70">{service.description}</p>
            </div>
          </motion.article>
        ))}
        <motion.a
          href="#booking"
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, delay: 0.3, ease: [0.22, 1, 0.36, 1] }}
          data-testid="services-booking-cta"
          className="group flex flex-col justify-between rounded-2xl bg-brand-accent p-8 text-white shadow-[0_8px_32px_rgba(190,24,93,0.25)] transition-transform duration-300 hover:-translate-y-1 md:col-span-5"
        >
          <p className="font-display text-2xl font-medium leading-snug md:text-3xl">
            Not sure what your nails need? Let&rsquo;s talk it through.
          </p>
          <span className="mt-8 inline-flex items-center gap-2 text-sm font-medium">
            Book a visit
            <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
          </span>
        </motion.a>
      </div>
    </div>
  </section>
);
